module.exports = __webpack_public_path__ + "img/thumbnail_KingPenguin_f_normal.ef48edbd.png";